import React from 'react';


class Forbidden extends React.Component {
    render() {
        return (
            <div>
                Forbidden
            </div>
        )
    }
}


export default Forbidden;